/**
 * General custom modal component. Used in components where any confirmations are required.
 */

//styles and images
import { H3 } from "../../../styles/styles";
import PortalModal from "../modal/PortalModal";

const CustomModal = ({ open, onClose, title, children, noClose, alignItems, padding, contentWidth, details }) => {
  return (
    <PortalModal 
      open={open} 
      onClose={onClose} 
      showCloseButton={!noClose}
      alignItems={alignItems}
      padding={padding}
      contentWidth={contentWidth}
      details={details}
    >
      {title && <H3>{title}</H3>}
      {children}
    </PortalModal>
  );
};

export default CustomModal;
